// extracted by css-extract-rspack-plugin
export default {"launchCell":"JZ5lWnimV0AFB9B6","launchButton":"eUN4c4E8cXwnPG1_","familyText":"bzaOZRSHvxsapk6T","repoText":"_dtJ2nkSqaw9PMXJ"};